export default __webpack_public_path__ + "static/media/logo.ff995d89.png";